import React,{useState, useContext} from 'react';

import {
    Row,
    Col,            
    Button, 
    Alert,   
    FormControl
} from 'react-bootstrap';
import UserContext from './../../contexts/UserContext';
import {Uploader} from '../../components';
import Utils from '../../Utils';
import axios from 'axios';

import _ from 'lodash';

const PhotoForm = (props) => {

  const isEdit = () => {
    return parseInt(_.get(props,'mode',0)) > 0;
  };
  const [photo, setPhoto] = useState(_.get(props,'data.fname', props.pos));
  const [size, setSize] = useState(_.get(props,'data.size', 0));
  const [title, setTitle] = useState(_.get(props,'data.title', isEdit() ? 'Slide ' + props.pos : ''));
  const [audio, setAudio] = useState(_.get(props,'data.audio', ''));
  const [errMsg,setErrMsg] = useState('');
  const imagesize_in_mb =  _.get(process.env,'REACT_APP_MAX_IMAGE_SIZE',1);
  const scormsize_in_mb = _.get(process.env,'REACT_APP_MAX_SCORM_SIZE',50);
  const {getPkgSize,getAvailableSize} = useContext(UserContext);
  
  const onUploadPhoto = (attr,status) => {  
    if(status==='error_file_size'){
      setErrMsg(`You have uploaded ${(attr.meta.size/1024/1024).toFixed(1)} MB file, however, 
      the acceptable maximum file size is ${getAvailableSize(imagesize_in_mb)} MB. Try again with an acceptable sized file.`);
    }else{  
      let file_size = (status.size/1024/1024).toFixed(1);
      setSize(file_size);
      let tot_size = parseInt(file_size) + getPkgSize();
      if(tot_size > scormsize_in_mb){
        setErrMsg(`Total SCROM size allowed is ${scormsize_in_mb} MB,You have used ${getPkgSize()} MB.`);
        return;
      }else{
        setErrMsg('');
        var tmp = attr;          
        setPhoto(tmp);
      } 

    }
  }

  const removeImageHandler = () => {
    if(window.confirm('Are you sure to delete this image')){
      axios.delete(Utils.apiUrl('delfile?file=' + photo), Utils.apiHeaders());
      setPhoto('');
    }
  }

  const removeAudio = () => {    
    if(window.confirm('This will remove the audio file.. continue?')){
      axios.delete(Utils.apiUrl('delfile?file=' + audio), Utils.apiHeaders());
      setAudio('');
    }
  }
  
  const submitSlide = () => {  
    if(title === ''){
      alert("Please enter title");      
      return;      
    }else if (photo === '1'){
      alert("'Please select image");
      return;
    }
    else{
      props.onFinalize({
        fname: photo, 
        size: size,
        title: title, 
        audio: audio,
        manual: isEdit() ? _.get(props,'data.manual', false) : true
      },'Photo',isEdit());
    }
    
  }

  return <>
  <div className="photoedit popcotentpad">
    <Row className="m-3">      
      <Col sm={12}>        
        <FormControl placeholder="Photo Title" defaultValue={title} onChange={(e) => {setTitle(e.currentTarget.value)}} /></Col>
    </Row>
    {!isEdit() && <Row className="mx-3">      
      <Col sm={12} className="text-left" style={{overflow: 'auto'}}>
        <p><strong>Image</strong> <i className="img icon"></i></p>
        <Uploader 
        instructions={`To upload Image file (max allowed ${getAvailableSize(imagesize_in_mb)} MB), click here or drag-drop the Image here`}
        accept="image/*" 
        maxSizeBytes={getAvailableSize(imagesize_in_mb)*1024*1024} 
        uploadUrl={Utils.apiUrl('saveupload')} 
        onUpload={onUploadPhoto} />        
      </Col>    
    </Row>} 
    {isEdit() && <Row className="mx-3">
    
      {photo && <>
          
          <Col sm={12} className="text-center" style={{overflow: 'auto'}} >
            {props.data && <img src={Utils.apiUrl(`image?f=${photo}`)} className="logoContainer" alt="slide" style={{width:"80%"}} />}
            {(props.data === undefined) && <img src={`${props.src}&nothumb=1`} className="logoContainer" alt="slide" style={{width:"80%"}} />}
            {props.data && <img src={`${process.env.PUBLIC_URL}/images/minus_circle_icon.png`} className="text-right photoRemove" onClick={removeImageHandler} alt="Remove" />}
          </Col>
        </>
      }
         
      </Row>}
    {errMsg!=='' && <>
      <Row className="mx-3 mb-4">  
        <Col className="text-center"><Alert variant="danger" className="p-3">
          <i className="fa fa-exclamation-circle" /> {errMsg} </Alert> 
        </Col>
      </Row>
    </>}
    <Row className="mx-3">      
      {audio==='' && <>
      <p><strong>Audio</strong> <i className="aud icon"></i></p>
        <Col sm={12} className="text-left" style={{overflow: 'auto'}}>
          <Uploader accept="audio/*" uploadUrl={Utils.apiUrl('saveupload')} onUpload={setAudio} />
        </Col>     
      </>}
      {audio!=='' && <>
        <Col sm={11}>
          <audio controls>      
            <source src={Utils.apiUrl(`file?f=${audio}`)} type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
          <span className="fa fa-2x fa-trash text-primary clickable ml-3 mt-2 position-absolute" title="Remove Audio" onClick={removeAudio} />
        </Col>        
      </>}
    </Row>
  <Row>
    <Col className="text-center p-2 cta">      
      <Button onClick={submitSlide} variant="success" disabled={(!isEdit() && photo==='') || (isEdit() && photo==='')}>Save</Button>
    </Col>
  </Row>  
  </div>
  </>
}

export default PhotoForm;